import { Component } from '@angular/core';
import { NgStyle } from '@angular/common';
import { TemplateListComponent } from './template-list/template-list.component';
import { DrillsListComponent } from './drills-list/drills-list.component';

@Component({
  selector: 'app-setup',
  standalone: true,
  imports: [NgStyle, TemplateListComponent, DrillsListComponent],
  templateUrl: './setup.component.html',
  styleUrl: './setup.component.css'
})
export class SetupComponent {

  activeTab: 'sessions' | 'templates' | 'drills' = 'drills';

  getTabUnderlineStyle() {
    const index = ['templates', 'drills'].indexOf(this.activeTab);
    return {
      width: 50 + '%',
      transform: `translateX(${index * 100}%)`
    };
  }
}
